import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { PHBHPFeaturePackageAuthorizationService } from '../ph-bhp-feature-package-authorization.service';
import { UserData } from '../Models/Models';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ProfileService } from 'profile/profile.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'profile/api.service';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-change-password',
  templateUrl: './ph-bhp-change-password.component.html',
  styleUrls: ['./ph-bhp-change-password.component.css']
})
export class PhBhpChangePasswordComponent implements OnInit {
  @Output() childData = new EventEmitter();
  @Input() userData: UserData;
  changePasswordForm: UntypedFormGroup;

  hide = true;
  hide1 = true;
  hide2 = true;
  dataToPass;
  submitted: boolean = false;
  showLableView: boolean = false;
  confirmPassword: boolean = false;
  confirmPasswordVal;
  @ViewChild('confirmPasswordModel') confirmPasswordModel;
  public barLabel: string = "Strength:";
  langSubscription: Subscription;
  public strengthLabels = [
    'Too weak',
    'Weak',
    'Fair',
    'Good',
    'Strong'
  ];

  errorMessageLength = '';
  errorMessageUpper = '';
  errorMessageLower = '';
  errorMessageSpecial = '';
  errorMessageMarked = '';
  errorMessageTypo = '';
  errorMessageNumber = '';
  specialCharacters = '\\ !?@#~%"#$%&\/=\'^*+-_`.,:;()[]{}';
  markedChars = ''
  firstMarkedChar = '';
  firstTypoChar = '';
  translationKeys: typeof TranslationKeys = TranslationKeys;
  showErrors = false;

  constructor(private service: PHBHPFeaturePackageAuthorizationService, public layoutService: PHBHPLayoutPackageService, public translate: TranslateService,
    private userService: ProfileService, private router: Router, public dialog: MatDialog, private formbuilder: UntypedFormBuilder, private apiService: ApiService) { }

  ngOnInit() {
    this.changePasswordForm = this.formbuilder.group({
      currentPassword: ["", Validators.required],
      newPassword: ["", Validators.required],
      confirmPasswordVal1: ["", Validators.required],
    })

    this.strengthLabels = [
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthTooWeak),
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthWeak),
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthFair),
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthGood),
      this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthStrong)
    ];
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.strengthLabels = [
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthTooWeak),
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthWeak),
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthFair),
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthGood),
        this.layoutService.translateText(this.translationKeys.Authorization.PasswordStrengthStrong)
      ];
    })
    this.submitted = false;
    this.changePasswordForm.reset();

  }


  ngOnDestroy() {

    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }


  get f() {
    return this.changePasswordForm.controls;
  }

  checkPassword(text) {
    var expUpper = /(?=.*?[A-Z])/; //uppercase
    var expLower = /(?=.*?[a-z])/; //lowercase
    var expNumber = /(?=.*?[0-9])/i; // number
    var expSpecial = /(?=.*?[ !#$%&\'()\\*+,-.\/:;=?@[\]^_`{|}~])/i; //(){}[]|`|! "$%^&*":;#~_-+=,@€
    var markedChars = /(?=.*?[À-ÿ])|(?=.*?[ŔŕŞşŢţȚțŬŭǓǔŮůǗǘǛǜǙǚǕǖŰűŨũṸṹŲųŪūṺṻỦủȔȕȖȗƯưỨứỪừỮữỬửỰựỤụṲṳṶṷṴṵɄʉᵾᶙĪīꜶꜷȢȣᵫĮįČčĎďĚěŇňŘřŠšŤťŮůÝýŽžẞßÆæŒœĀāǢǣĒēŌōȲȳŐőĂăĄąĐđǴǵĞğĶķĻļŁłĹĺĽľĻļḶḷŹźẐẑŽžŻżẒẓẔẕŃńǸǹŇň])/; // marked chars
    var typographicalChars = /(?=.*?[×÷·•≈❦❧⟨⟩⁂‰‱‸⁁⎀€£<>¬◌̂©¤†‡⌀⹀⸗℮ºª♀♂⚥«»‽¶±®§℠℗∴™⁀⸿፠๛])/; // typographical chars

    var valid = true;

    this.errorMessageLength = '';
    this.errorMessageUpper = '';
    this.errorMessageLower = '';
    this.errorMessageSpecial = '';
    this.errorMessageNumber = '';
    this.errorMessageMarked = '';
    this.errorMessageTypo = '';
    this.firstMarkedChar = '';
    this.firstTypoChar = '';
    if (text.length < 8) {
      this.errorMessageLength = 'AUTHORIZATION.PASS_VERIFY.LENGTH';
      valid = false;
    }
    if (!text.match(expUpper)) {
      this.errorMessageUpper = 'AUTHORIZATION.PASS_VERIFY.UPPERCASE';
      valid = false;
    }
    if (!text.match(expLower)) {
      this.errorMessageLower = 'AUTHORIZATION.PASS_VERIFY.LOWERCASE';
      valid = false;
    }
    if (!text.match(expNumber)) {
      this.errorMessageNumber = 'AUTHORIZATION.PASS_VERIFY.NUMBER';
      valid = false;
    }
    if (!text.match(expSpecial)) {
      this.errorMessageSpecial = 'AUTHORIZATION.PASS_VERIFY.SPECIAL';
      valid = false;
    }
    if (text.match(markedChars)) {
      this.errorMessageMarked = 'AUTHORIZATION.PASS_VERIFY.MARKED';
      var res = /([À-ÿ]|[ŔŕŞşŢţȚțŬŭǓǔŮůǗǘǛǜǙǚǕǖŰűŨũṸṹŲųŪūṺṻỦủȔȕȖȗƯưỨứỪừỮữỬửỰựỤụṲṳṶṷṴṵɄʉᵾᶙĪīꜶꜷȢȣᵫĮįČčĎďĚěŇňŘřŠšŤťŮůÝýŽžẞßÆæŒœĀāǢǣĒēŌōȲȳŐőĂăĄąĐđǴǵĞğĶķĻļŁłĹĺĽľĻļḶḷŹźẐẑŽžŻżẒẓẔẕŃńǸǹŇň])/.exec(text);
      if (res && res.length > 0) {
        this.firstMarkedChar = res[0];
        valid = false;
      }
    }
    if (text.match(typographicalChars)) {
      this.errorMessageTypo = 'AUTHORIZATION.PASS_VERIFY.TYPOGRAPHICAL';
      var res = /([×÷·•≈❦❧⟨⟩⁂‰‱‸⁁⎀€£<>¬◌̂©¤†‡⌀⹀⸗℮ºª♀♂⚥«»‽¶±®§℠℗∴™⁀⸿፠๛])/.exec(text);
      if (res && res.length > 0) {
        this.firstTypoChar = res[0];
        valid = false;
      }
    }
    if (valid) {
      this.showErrors = false;
      this.changePasswordForm.controls.newPassword.setErrors(undefined);
    } else {
      this.showErrors = true;
      this.changePasswordForm.controls.newPassword.setErrors({ 'incorrect': true });
    }

  }

  showStrengthLable(e: string) {
    if (e.length > 0) {
      this.showLableView = true;
    } else {
      this.showLableView = false;
    }
    if (this.changePasswordForm.value.newPassword == this.changePasswordForm.value.confirmPasswordVal1) {
      this.confirmPassword = false;
    } else {
      this.confirmPassword = true;
    }
  }

  passwordFun() {
    this.submitted = true;
    if (this.changePasswordForm.invalid) {
      return;
    }
    if (this.changePasswordForm.value.newPassword != this.changePasswordForm.value.confirmPasswordVal1) {
      this.confirmPassword = true;
      this.changePasswordForm.controls.confirmPasswordVal1.setErrors(undefined);
      return;
    } else {
      this.confirmPassword = false;
      this.changePasswordForm.controls.confirmPasswordVal1.setErrors({ 'incorrect': true });
    }

    this.changeMHSPassword();
  }


  cancelPwd() {
    this.router.navigate(['']);
  }


  changeMHSPassword() {
    var data = {
      Username: this.userData.username,
      OldPassword: this.changePasswordForm.value.currentPassword,
      NewPassword: this.changePasswordForm.value.newPassword
    }
    this.layoutService.showLoader = true;
    this.apiService.changeMHSPassword(data).subscribe({
      next: res => {
        this.layoutService.showLoader = false;
        this.changePasswordForm.reset();
        this.confirmPasswordVal = "";
        this.showLableView = false;
        if (!res) {
          this.submitted = false;
          this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.ENTER_VALID_PASSWORD'));
        } else {
          this.hide = true;
          this.hide1 = true;
          this.hide2 = true;
          this.childData.emit('done');
          this.layoutService.showSuccess(this.layoutService.translateText(this.translationKeys.SuccessMessages.PasswordUpdated));
          this.showLableView = false;
        }
      },
      error: err => {
        this.layoutService.showLoader = false;
        if (err.error.message != '') {
          this.changePasswordForm.reset();
          this.showLableView = false;
          this.confirmPasswordVal = "";
          this.submitted = false;
          this.hide = true;
          this.hide1 = true;
          this.hide2 = true;
        }
      }
    })
  }
}
